import { ReactNode, lazy, Suspense } from 'react';
import Header from 'src/view/layout/Header';
import version from 'src/config/version.json';

import LayoutWrapper from 'src/view/layout/styles/LayoutWrapper';

import AntLayout from 'antd/es/layout';
import Flex from 'antd/es/flex';

const TermsAndConditions = lazy(
  () => import('src/modules/shared/terms/TermsAndConditions'),
);

const ReleaseNotificationPopup = lazy(
  () => import('src/view/shared/releaseNotification/ReleaseNotificationPopup'),
);

const { Content, Footer } = AntLayout;

const year = new Date().getFullYear();

type Props = {
  isLoggedIn?: boolean;
  hasSubroutes?: boolean;
  children: ReactNode;
};

const Layout = (props: Props) => {
  if (!props.isLoggedIn) {
    return props.children;
  }

  return (
    <LayoutWrapper>
      <AntLayout>
        <Header />

        <Content className={props.hasSubroutes ? '' : 'space-arround'}>
          {props.children}
        </Content>

        <Suspense>
          <ReleaseNotificationPopup isLoggedIn={props.isLoggedIn} />
        </Suspense>

        <Footer>
          <Flex vertical align='center'>
            {`EU-Label ©${year} by SEMICOLON`}

            <Suspense>
              <TermsAndConditions inLine />
            </Suspense>

            <div>{`version: ${version.version}`}</div>
          </Flex>
        </Footer>
      </AntLayout>
    </LayoutWrapper>
  );
};

export default Layout;
